<template>
  <div id="paso2">
    <paso-actual />
    <puestos />
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <label for="nivelEstudio">M&#225;ximo nivel de estudio alcanzado <i class="fas fa-asterisk"></i></label>
        <select class="custom-select" v-model="nivelEstudio">
          <option v-for="nivel in nivelesDeEstudio" :key="nivel.key" :value="nivel">{{ nivel.nombre }}</option>
        </select>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <label for="tituloHabilitante">T&#237;tulo habilitante</label>
        <input type="text" class="form-control" v-model="tituloHabilitante" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <label>Concocimientos b&#225;sicos de computaci&#243;n <small>(word, excel, powerpoint, etc)</small> <i class="fas fa-asterisk"></i></label>
        <textarea v-model="conocimientosBasicos" class="form-control"></textarea>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <label for="trabajoReferencia">Trabajos de referencia <i class="fas fa-asterisk"></i></label>
        <textarea v-model="trabajoReferencia" class="form-control"></textarea>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-xs-6 col-sm-6 col-md-12 col-lg-12">
        <label for="sectorPostula">Sector al que se postula <i class="fas fa-asterisk"></i></label>
        <button class="btn btn-default btn-sm" @click="mostrarPuestos">···</button>
        <!--<select v-model="sectorPostula" id="sectorPostula" class="custom-select">
          <option value="0"></option>
          <option v-for="sector in sectores" :key="sector.key" :value="sector.id">
            {{ sector.nombre }}
          </option>
        </select>-->
        <span v-if="sectorPostula">{{ sectorPostula.nombre }}</span>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div v-if="sectorPostula.id==9 && sectorPostula.pm=='0'">
          <label for="otroSector">Especifique el sector: </label>
          <input type="text" v-model="otroSector" class="form-control" />
        </div>
      </div>
    </div>

    <hr />

    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <button class="btn btn-success btn-sm" @click="confirmar">Continuar</button>
        <button class="btn btn-primary btn-sm ml-2 atras" @click="$emit('continuar', 1)">Atr&#225;s</button>
      </div>
    </div>
  </div>
</template>

<script>
  import PasoActual from './PasoActual';
  import Puestos from './Puestos';
  import EventBus from '../EventBus';
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      trabajoReferencia: '',
      conocimientosBasicos: '',
      //sectorPostula: '',
      otroSector: '',
      nivelEstudio: '',
      tituloHabilitante: ''
    }),
    computed: {
      ...mapGetters({
        sectores: 'sectores/getData',
        sectorPostula: 'postulante/getSectorPostula',
        nivelesDeEstudio: 'nivel_estudio/getData'
      })
    },
    methods: {
      confirmar: function() {
        if(this.nivelEstudio==undefined || this.nivelEstudio==null || this.nivelEstudio=='') {
          return EventBus.$emit('MOSTRAR_MENSAJE', 'Debe ingresar el maximo nivel de estudio alcanzado!');
        }
        if(this.conocimientosBasicos.trim()=='') {
          return EventBus.$emit('MOSTRAR_MENSAJE', 'Debe ingresar sus conocimientos basicos de computacion!');
        }
        if(this.trabajoReferencia.trim()=='') {
          return EventBus.$emit('MOSTRAR_MENSAJE', 'Debe ingresar el(los) trabajo(s) de referencia!');
        }
        if(this.sectorPostula==0) {
          return EventBus.$emit('MOSTRAR_MENSAJE', 'Debe seleccionar el sector al cual se postula!');
        }
        if(this.sectorPostula==9 && this.otroSector.trim()=='') {
          return EventBus.$emit('MOSTRAR_MENSAJE', 'Debe especificar a que otro sector se postula!');
        }

        this.$store.commit('postulante/setNivelEstudio', this.nivelEstudio);
        this.$store.commit('postulante/setTituloHabilitante', this.tituloHabilitante);
        this.$store.commit('postulante/setTrabajoReferencia', this.trabajoReferencia);
        this.$store.commit('postulante/setConocimientosBasicos', this.conocimientosBasicos);
        this.$store.commit('postulante/setSectorPostula', this.sectorPostula);
        this.$store.commit('postulante/setOtroSectorPostula', this.otroSector);
        this.$emit('continuar', 3);
      },
      mostrarPuestos: function() {
        EventBus.$emit('MOSTRAR_PUESTOS', true);
      }
    },
    activated() {
      this.$store.commit('pasos/setPasoActivo', 2);
    },
    components: {
      'paso-actual' : PasoActual,
      puestos: Puestos
    }
  }
</script>

<style lang="sass" scoped>
  .fa-asterisk
    color: #C62828
    font-size: 0.698rem
  .atras
    padding-left: 25px
    padding-right: 25px
  .form-control
    text-transform: uppercase
</style>



// WEBPACK FOOTER //
// src/components/Paso2.vue